import styled from 'styled-components'

import { applyButtonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const DangerButtonStyled = styled(BaseButton)`
  ${(props) =>
    applyButtonColorCSS(
      props.theme.colors.button.deny.background,
      undefined,
      undefined,
      props.theme.colors.button.deny.backgroundHover
    )}
`
